module.exports = __webpack_public_path__ + "img/American_Credit_Equipment_Financing_Flexible_Terms.11a7e66.png";